import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PanelledTee = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.PanelledTee.itemName}
      name={SS23.tops.PanelledTee.itemName}
      price={SS23.tops.PanelledTee.itemPrice}
      fabric={SS23.tops.PanelledTee.itemFabric}
      src={SS23.tops.PanelledTee.sizeChart}
      divId={SS23.tops.PanelledTee.shopifyDivId}
      mainId={SS23.tops.PanelledTee.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.PanelledTee.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.PanelledTee.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PanelledTee;
